export const SelectedCompanyParam = 'company';
export const SelectedTransactionParam = 'transaction';
